<template>
    <div class="loading d-flex align-items-center justify-content-center">
      <div class="row">
        <div class="loaderParent col-12 d-flex align-items-center justify-content-center">
          <div class="loaderElement loadingBackground"></div>
          <svg class="loaderElement loadingSpinner"viewBox='0 0 200 200'>
            <path d='M 190 100 A 90 90 0 0 1 100 190' />
          </svg>
        </div>
        <div class="col-12 d-flex align-items-center justify-content-center">
          <p class="title">Haetaan tietoja...</p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "LoadingView",
        props: ["title"]
    }
</script>

<style scoped>
  .title {
    margin-top: 20px;
    font-size: 24px;
  }

  .loaderParent {
    height: 20vh;
  }

  .loaderElement {
    position: fixed;
  }

  svg {
    height: 20vh;
    width: 20vh;
    fill: none;
    stroke: #0097D7;
    stroke-width: 1vh;
    stroke-linecap: round;
  }

  .loading {
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  }

  .loadingBackground {
    border: 2vh solid #FFFFFF;
    border-radius: 50%;
    width: 20vh;
    height: 20vh;
  }

  .loadingSpinner {
    animation: spin 1.5s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingView.vue